import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EnvironmentInjector } from '@next/core-lib/environment';
import { RoughagePlusEnvironment } from 'src/environments/environment.model';

import { AppNotification } from '../models/app-notification.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly http = inject(HttpClient);
  private readonly environment =
    inject<RoughagePlusEnvironment>(EnvironmentInjector);

  public getNotifications() {
    return this.http.get<AppNotification[]>(
      `${this.environment.API_BASE_URL}/service/dairy-advice/secure/notifications`,
    );
  }
}
